import { useState } from "react";
import { Link } from "@inertiajs/react";
import GoalType from "types/GoalType";
import goalTitlizer from "lib/goalTitlizer";
import Icon from "hardcover-ui/components/Icon";
import faBullseyeArrow from "icons/duotone/bullseye-arrow.svg";
import ActivityProps from "./ActivityFeedItemProps";

interface GoalActivityType extends GoalType {
  percentComplete: number;
}
interface GoalActivityDataType {
  goal: GoalActivityType;
}

export default function UserBookActivity({ activity }: ActivityProps) {
  const [user] = useState(activity.user);
  const [goal] = useState((activity.data as GoalActivityDataType).goal);

  const percentComplete = goal.percentComplete * 100;

  return (
    <div className="py-2 space-y-2">
      <p className="text-stone-800 dark:text-yellow-50 text-base">
        Updated a reading goal:
      </p>

      <div className="flex flex-wrap items-center justify-between border dark:border-gray-700 dark:hover:border-gray-600 py-3 px-4 rounded-xl w-full dark:bg-gray-800">
        <div className="flex items-center gap-3">
          <div className=" text-indigo-500 dark:text-yellow-400">
            <Icon icon={faBullseyeArrow} size="2xl" />
          </div>
          <div className="">
            <Link
              href={`/@${user.username}/goals/${goal.id}`}
              className="text-lg font-semibold text-stone-800 dark:text-yellow-100 hover:underline "
            >
              {goal.description}
            </Link>
            <p>{goalTitlizer(goal)}</p>
          </div>
        </div>

        <div className="flex justify-between">
          <p>
            Progress so far:{" "}
            <span className="py-1 px-2 rounded-xl dark:bg-gray-600 text-sm">
              {goal.progress} / {goal.goal}
            </span>{" "}
            <span className="py-1 px-2 rounded-xl dark:bg-gray-700">
              {Math.round(percentComplete)}%
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
